export const DEPARTMENT_CONSTRAINTS = {
    name: { maxLength: 64, label: 'Department name' },
};
//# sourceMappingURL=constraints.js.map